import { SET_REGION } from './mutations'

const state = {
  region: 'NA',
}

const getters = {

}

const mutations = {
  [SET_REGION] (state, region) {
    state.region = region
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
